import { render, staticRenderFns } from "./PaymentMethodOverview.vue?vue&type=template&id=58a65686&scoped=true&"
import script from "./PaymentMethodOverview.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodOverview.vue?vue&type=script&lang=js&"
import style0 from "./PaymentMethodOverview.vue?vue&type=style&index=0&id=58a65686&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a65686",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VInput } from 'vuetify/lib/components/VInput';
installComponents(component, {VBtn,VDataTable,VIcon,VInput})
